import React from 'react'
import { Link } from 'react-router-dom'

const NestedPageHero = ({ title }) => {
    return (
        <div className='page-banner-section'>
            <div className="text-center container">
                <div className="row">
                    <div className="col">
                        <h1 className='mb-2 text-white fs-1'>{title}</h1>
                        <div className="d-flex align-items-center justify-content-center gap-2">
                            <h3 className='mb-0'>
                                <Link className='text-decoration-none text-white' to={'/'}>Home</Link>
                            </h3>
                            <span className="text-secondary fs-3">-</span>
                            <h3 className="text-warning mb-0">{title}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NestedPageHero